import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import routes from './routes'

Vue.use(Router)

const resetNotification = (to, from, next) => {
  if (to.params.loaded) {
    store.dispatch('setNotification', {
      message: 'Votre compte est déjà connecté.',
      mode: 'danger'
    })
  } else if (to.params.successSignUp) {
    let message
    if (to.params.withTrainings) {
      message = 'Vous pouvez vous connecter pour suivre l\'avancement à votre formation.'
    } else {
      message = 'Vous serez contacté prochainement par l\'un(e) de nos collaborateur(trice)s'
    }
    store.dispatch('setNotification', {
      message: 'Votre demande d\'accès en tant que professionnel a été pris en compte. ' + message,
      mode: 'success',
      expiration: 0
    })
  } else if (to.params.noProduct) {
    store.dispatch('setNotification', {
      message: 'Vous ne pouvez enregistrer de demande d\'assistance sans produit',
      mode: 'danger',
      expiration: 8000
    })
  } else {
    store.commit('SET_NOTIFICATION', {
      message: null,
      mode: 'success'
    })
  }
  next()
}

export const genericRouter = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes
})

export const bestoveRouter = new Router({
  mode: 'history',
  base: process.env.NODE_ENV === 'production' ? process.env.BASE_URL : '/bestove',
  routes: routes
})

genericRouter.beforeEach((to, from, next) => resetNotification(to, from, next))
bestoveRouter.beforeEach((to, from, next) => resetNotification(to, from, next))
